/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentEntityType } from './CommentEntityType';
import {
    CommentEntityTypeFromJSON,
    CommentEntityTypeFromJSONTyped,
    CommentEntityTypeToJSON,
} from './CommentEntityType';

/**
 * 
 * @export
 * @interface ReactCommentRequestBody
 */
export interface ReactCommentRequestBody {
    /**
     * 
     * @type {CommentEntityType}
     * @memberof ReactCommentRequestBody
     */
    entityType: CommentEntityType;
    /**
     * ID of the entity (track) being commented on
     * @type {number}
     * @memberof ReactCommentRequestBody
     */
    entityId: number;
}

/**
 * Check if a given object implements the ReactCommentRequestBody interface.
 */
export function instanceOfReactCommentRequestBody(value: object): value is ReactCommentRequestBody {
    let isInstance = true;
    isInstance = isInstance && "entityType" in value && value["entityType"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function ReactCommentRequestBodyFromJSON(json: any): ReactCommentRequestBody {
    return ReactCommentRequestBodyFromJSONTyped(json, false);
}

export function ReactCommentRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReactCommentRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityType': CommentEntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'],
    };
}

export function ReactCommentRequestBodyToJSON(value?: ReactCommentRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityType': CommentEntityTypeToJSON(value.entityType),
        'entityId': value.entityId,
    };
}

